import { getArrayFromCacheOrFromEndpoint } from "../../utilities/cacheValidator";
import { IActionLinks, getActionListsFromEndpoint } from "./storeRequests";
import { APIAnomalyError } from "../../services/ErrorHelpers";
import { IUserProviderState } from "../UserContext";

export interface IWeightages {
  SendToPoster: number;
  Attachments: number;
  Delete: number;
  Recall: number;
  AddPosters: number;
  SubmitForReview: number;
  ApproveSLEntries: number;
  NeedsClarification: number;
  ExportToExcel: number;
  Save: number;
  Validate: number;
  ClearForm: number;
}

export async function getActionLists(getTokenFn: IUserProviderState["accessToken"]): Promise<IActionLinks[]> {
  const actionList = await getArrayFromCacheOrFromEndpoint<IActionLinks[]>(
    "ActionLists",
    getActionListsFromEndpoint,
    getTokenFn
  );
  return actionList;
}

export async function fetchAndParseActionLinks(getTokenFn: IUserProviderState["accessToken"]): Promise<{
  actions: IActionLinks[];
  weightages: IWeightages;
}> {
  const actionList = await getActionLists(getTokenFn);
  if (actionList.length === 0) {
    throw new APIAnomalyError("Received empty Array for Action Lists");
  }
  const actions = actionList;
  const weightages = actionList.reduce((ctr, action) => {
    ctr[action.action as keyof IWeightages] = action.weightage;
    return ctr;
  }, {} as IWeightages);
  return {
    actions,
    weightages
  };
}
